
module.exports = function getResource(label, vars = []) {
    let resources = {
        backToLists: 'Retourner aux listes'
    };
    return resources[label];
};
